import { FormControl, Select } from '@material-ui/core';
import React from 'react';
import { Lab } from '../../swagger';
import { api } from '../../utils/api';

interface LabSelectProps {
  value: string;
  onChange: (locality: string) => void;
}

export const LabsSelect: React.FC<LabSelectProps> = (props) => {
  const [labs, setLabs] = React.useState<Lab[]>([]);

  React.useEffect(() => {
    api
      .productControllerGetLabs()
      .then((labsResult) => sortAndRemoveDuplicates(labsResult))
      .catch((error) => console.log(error));
  }, []);

  const sortAndRemoveDuplicates = (labs: Lab[]): void => {
    setLabs(
      labs
        .sort((a, b) => (a.locality > b.locality ? 1 : -1))
        .reduce((a: Lab[], b: Lab) => {
          if (!a.length) a[0] = b;
          if (b.locality != a[a.length - 1].locality) a.push(b);
          return a;
        }, []),
    );
  };

  return (
    <FormControl
      style={{ width: '14em', float: 'left' }}
      variant="outlined"
      size="small"
    >
      <Select
        native
        labelId="labs-select-label"
        id="labs-select"
        value={props.value}
        onChange={(event) => {
          props.onChange(event.target.value as string);
        }}
      >
        <option key="-" value="" />
        {labs.map((lab) => (
          <option key={lab.locality} value={lab.locality}>
            {lab.locality}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};
